<template>
  <curl-response v-bind:curl="curl" request="Catalog"></curl-response>
</template>

<script>
import curl from 'services/curl'
import CurlResponse from 'components/CurlResponse'

export default {
  name: 'curl-catalog',
  data () {
    return {
      curl: null
    }
  },
  created () {
    var session = this.$route.query.session
    curl.catalog(this, session)
  },
  components: {
    CurlResponse
  }
}
</script>



// WEBPACK FOOTER //
// src/views/curl/CurlCatalog.vue